import { ref, watch, onMounted, onBeforeUnmount } from "vue";
import { useRoute } from "vue-router";

const DESKTOP_BREAKPOINT = 1024;

export const sidebarOpen = ref(false);

const isDesktopViewport = () =>
  typeof window !== "undefined" && window.innerWidth >= DESKTOP_BREAKPOINT;

const updateBodyScrollLock = () => {
  if (typeof document === "undefined") return;
  const shouldLock = sidebarOpen.value && !isDesktopViewport();
  document.body.style.overflow = shouldLock ? "hidden" : "";
};

export const openSidebar = () => {
  sidebarOpen.value = true;
  updateBodyScrollLock();
};

export const closeSidebar = () => {
  sidebarOpen.value = false;
  updateBodyScrollLock();
};

export const toggleSidebar = () => {
  sidebarOpen.value = !sidebarOpen.value;
  updateBodyScrollLock();
};

export function useLayoutInit() {
  const route = useRoute();

  watch(
    () => route.path,
    () => {
      closeSidebar();
    }
  );

  const handleResize = () => {
    if (isDesktopViewport()) {
      closeSidebar();
    } else {
      updateBodyScrollLock();
    }
  };

  onMounted(() => {
    window.addEventListener("resize", handleResize);
  });

  onBeforeUnmount(() => {
    window.removeEventListener("resize", handleResize);
    document.body.style.overflow = "";
  });
}
